// extracted by mini-css-extract-plugin
export default {"tecnologiesContainer":"styles_tecnologiesContainer__z4+0Y"};